import { ConsignmentVendorSalesListPage } from "@/features/consignment-vendor-sales/pages/ConsignmentVendorSalesListPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/consignment-vendor-sales/")({
	component: ConsignmentVendorSalesListPage,
});
